var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariablesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    d: "M7.31 9.221c-.257-.257-.338-.593-.18-.75l1.297-1.298c.158-.158.494-.076.751.18l2.778 2.78 2.78-2.78c.257-.257.593-.338.75-.18l1.298 1.298c.157.157.076.493-.18.75l-2.78 2.78 2.78 2.778c.228.229.317.52.224.692l-.044.058-1.298 1.298c-.157.158-.493.077-.75-.18l-2.78-2.78-2.778 2.78c-.257.256-.593.338-.75.18L7.13 15.53c-.158-.157-.077-.493.18-.75L10.09 12ZM1.5 2h4a.5.5 0 0 1 .5.5v1.027a.5.5 0 0 1-.505.5l-.99-.01a.5.5 0 0 0-.505.5v14.977a.5.5 0 0 0 .493.5l1.014.014a.5.5 0 0 1 .493.5v.992a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-19a.5.5 0 0 1 .5-.5Zm21 0h-4a.5.5 0 0 0-.5.5v1.027a.5.5 0 0 0 .505.5l.99-.01a.5.5 0 0 1 .505.5v14.977a.5.5 0 0 1-.493.5l-1.014.014a.5.5 0 0 0-.493.5v.992a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-19a.5.5 0 0 0-.5-.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariablesIcon);
export default __webpack_public_path__ + "static/media/variables-icon.1bb35b577fc3f11a508144cdc8b09ef4.svg";
export { ForwardRef as ReactComponent };